import { batchActions } from "redux-batched-actions";
import {changePage, displayErrorMessage, displaySuccessMessage, updatePageDetails} from '@insticator/insticator-ui'; // iui-utils
import { asyncRequestCommentingWidget, asyncGetCommentingData, asyncHasCommentingUnit, asyncCreateCommentingUnit, asyncApproveCommenting, asyncGetCommentingEmailIfExist } from 'utils/api/commenting';

export const RECEIVE_COMMENTING_DATA = "RECEIVE_COMMENTING_DATA";
export const COMMENTING_DATA_FAIL = "COMMENTING_DATA_FAIL";
export const COMMENT_REQUEST_PENDING = "COMMENT_REQUEST_PENDING";
export const FETCHING_COMMENT_DATA = "FETCHING_COMMENT_DATA";
export const RECEIVE_COMMENTING_UNIT_CHECK = 'RECEIVE_COMMENTING_UNIT_CHECK';
export const SELECT_SITE = "SELECT_SITE";
export const APPROVING_COMMENTING = "APPROVING_COMMENTING";
export const COMMENT_REQUEST_SENT = 'COMMENT_REQUEST_SENT';
export const FETCHING_COMMENTING_EMAIL_IF_EXIST = 'FETCHING_COMMENTING_EMAIL_IF_EXIST'
export const RECEIVE_COMMENTING_EMAIL_IF_EXIST = 'RECEIVE_COMMENTING_EMAIL_IF_EXIST'

const commentStatusSuccess = (userEmail) => batchActions([commentRequestSent(userEmail), commentRequestPending(false), displaySuccessMessage("Your request was sent successfully")]);
const commentStatusFail = () => batchActions([commentRequestPending(false), displayErrorMessage("There was an issue making your request.") ]);

const getCommentingDataSuccess = data => batchActions([fetchingCommentData(false), receiveCommentData(data)]);
const getCommentingDataFail = () => batchActions([fetchingCommentData(false), commentDataFail(), displayErrorMessage("There was an issue fetching your commenting data.")])

const approveCommentingSuccess = data => batchActions([receiveCommentData(data), approvingCommenting(false)]);
const approveCommentingFail = () => batchActions([displayErrorMessage("There was an issue approving this account."), approvingCommenting(false)]);

const receiveCommentData = data => ({
    type: RECEIVE_COMMENTING_DATA,
    userEmail: data.userEmail,
    requestStatus: data.requestStatus
});

const commentDataFail = () => ({
    type: COMMENTING_DATA_FAIL
});

const commentRequestPending = status => ({
   type: COMMENT_REQUEST_PENDING,
   status
});

const commentRequestSent = userEmail => ({
    type: COMMENT_REQUEST_SENT,
    userEmail
})

const fetchingCommentData = status => ({
    type: FETCHING_COMMENT_DATA,
    status
});

export const selectCommentSite = site => ({
   type: SELECT_SITE,
   site
});

export const receiveCommentingUnitCheck = state => ({
    type: RECEIVE_COMMENTING_UNIT_CHECK,
    state
});

export const approvingCommenting = status => ({
    type: APPROVING_COMMENTING,
    status
});

const fetchingCommentingEmailIfExist = state => ({
    type: FETCHING_COMMENTING_EMAIL_IF_EXIST,
    state
});

export const receiveCommentingEmailIfExist = isExist => ({
    type: RECEIVE_COMMENTING_EMAIL_IF_EXIST,
    isExist
});

export const requestCommentWidget = (accountUUID, userEmail) => dispatch => {
    dispatch(commentRequestPending(true));
    asyncRequestCommentingWidget(accountUUID)
        .then(() => dispatch(commentStatusSuccess(userEmail)))
        .catch(err => dispatch(commentStatusFail()))
};

export const getCommentingData = (accountUUID) => dispatch => {
    dispatch(fetchingCommentData(true));
    asyncGetCommentingData(accountUUID)
        .then(response => dispatch(getCommentingDataSuccess(response.data)))
        .catch(err => console.log(err) || dispatch(getCommentingDataFail()))
};

export const checkForCommentingUnit = (siteUUID) => dispatch => {
    dispatch(fetchingCommentData(true));
    asyncHasCommentingUnit(siteUUID)
        .then(response => dispatch(receiveCommentingUnitCheck(response.data)))
        .catch(err => console.log(err))
};

export const createCommentingUnit = (accountUUID, siteUUID) => dispatch => {
    dispatch(commentRequestPending(true));
    asyncCreateCommentingUnit({ 'siteUUID': siteUUID})
        .then(response => {
            console.log(response);
            console.log(response.status === 200);
            dispatch(getCommentingDataSuccess({ requestStatus: 'APPROVED', userEmail: 'info@insticator.com'}))
        })
        .then(() => dispatch(updatePageDetails('dashboard/commenting/commentmanager')))
        .then(() => dispatch(changePage('dashboard/commenting/commentmanager')))
        .catch(err => console.log(err) || dispatch(displayErrorMessage('There was an issue creating the content unit')))
};

export const approveCommenting = accountUUID => dispatch => {
  dispatch(approvingCommenting(true));
    asyncApproveCommenting(accountUUID)
        .then(response => dispatch(approveCommentingSuccess(response.data)))
        .catch(err => dispatch(approveCommentingFail()))
};

export const getCommentingEmailIfExist = (email) => dispatch => {
    dispatch(fetchingCommentingEmailIfExist(true))
    asyncGetCommentingEmailIfExist(email)
        .then(response => {
            dispatch(receiveCommentingEmailIfExist(response.data))
        })
        .catch(err => console.log(err))
};